import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Skill } from '@src/types/shared/skill';
import type { RootState } from '..';

type State = { skills: Skill[] };

const initialState: State = { skills: [] };

const skillSlice = createSlice({
  name: 'skill',
  initialState,
  reducers: {
    addSkill(state, action: PayloadAction<Skill>) {
      state.skills.push(action.payload);
    },
    updateSkill(state, action: PayloadAction<{ index: number; item: Skill }>) {
      const { index, item } = action.payload;
      if (index >= 0 && index < state.skills.length) {
        state.skills[index] = item;
      }
    },
    updateSkillsFromStorage(state, action: PayloadAction<Skill[]>) {
      state.skills = action.payload;
    },
    removeSkill(state, action: PayloadAction<number>) {
      state.skills.splice(action.payload, 1);
    },
  },
});

export const { addSkill, updateSkill, updateSkillsFromStorage, removeSkill } = skillSlice.actions;

export const selectSkill = (state: RootState): Skill[] => state.skill.skills;

export default skillSlice.reducer;
